<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'" (onHide)="closeCustomerDialogue()"
   [dismissible]="false" [style]="{width:'60rem'}">
   <ng-template pTemplate="header">
      {{ customerSupportData ? 'Update Client (' + customerSupportData.firstName + ' ' +
      customerSupportData.lastName + ')' : 'Add Client' }}
   </ng-template>
   <ng-template pTemplate="content">
      <app-client-addupdate [currentCustomer]="customerSupportData" [userData]="userDataFromuserList"
         (changeModelStatus)="changeAddUpdateModelState($event)"></app-client-addupdate>
   </ng-template>
</p-sidebar>


<app-client-list [customerListData]="clientData"
   (changeModelStatus)="changeAddUpdateModelState($event)"></app-client-list>